import { Col, Row, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { MessageIcon, UnassignDriverIcon } from "../../common/CustomIcon";
import DriverIcon from "../../../assets/images/driver_icon.svg";
import MessageDriver from "./MessageDriver";
import { formatFullName, renderAlertMessage } from "../../helpers/common";
import { alertMessage } from "../../common/Common";
import { deleteRoutes, deleteStopFromDispatch } from "../../api/Routes";
import I18n from "../../common/I18n";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import AppConfig from "../../config/AppConfig";
import DisplayTime from "../../components/common/DisplayTime";
import { deleteSingleStop } from "../../api/OrdersApi";

const AssignedDriver = ({
  driverDetails = {},
  drivers,
  location,
  currentOrg,
  currentOrder,
  refreshDetails = () => {},
  showActions = true,
  orgSettings = {},
}) => {
  const [messageDriver, setMessageDriver] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [locked, setLocked] = useState(false); 
  const isAssignable = orgSettings?.order_assign_without_restriction === "true"  ? location.is_assignable : true;
  useEffect(() => {
    if (!showActions || currentOrder?.customer_order_details?.is_locked !== undefined) {
        setLocked(!showActions || currentOrder.customer_order_details.is_locked === "true" || currentOrder.is_deleted_order ? true : false);
    }
}, [currentOrder]);

  const getStopType = () => {
    if (currentOrder?.type_of_order === "LH") return "LH";
    const stopCodes = {
      REC: "RC",
      TRANS: "RL"
    };

    return stopCodes[location?.label_code] || "CS";
  };

  const unlinkDriver = () => {
    setIsLoading(true);
    let stop;
    const data = {
      nav_route_id: driverDetails?.nav_route_id || "",
      nav_stop_id: driverDetails?.nav_stop_id || "",
      order_ids_to_delete: currentOrder?.id ? [currentOrder.id] : [],
      location_ids_to_delete: location?.id ? [location.id] : [],
      deletion_reason: ["Deleted Form Order"],
      stop_type: getStopType(),
      org_id: currentOrg?.id || "",
    };

    const msPayload = {
      location_id: location?.id || "",
      order_id: currentOrder?.id || "",
      organization_id: currentOrg?.id || "",
      action_type: "REMOVE_DRIVER"
    }
    
    if (currentOrder?.type_of_order === 'MS') {
      stop = currentOrder?.locations?.find(stop => stop?.driver_details?.nav_stop_id == driverDetails?.nav_stop_id)
    }
    let func = currentOrder?.type_of_order === 'MS' ? () => deleteSingleStop(msPayload) : () => deleteStopFromDispatch(data, 'ORDER');
    func().then((result) => {
      if (result.success) {
        renderNotification("Deleted from route", "success");
        alertMessage(I18n.t("messages.deleted"), "success", 5);
        setIsLoading(false);
        refreshDetails();
      } else {
        renderAlertMessage(result.errors);
        setIsLoading(false);
      }
    });
  };
  return (
    <Spin spinning={isLoading}>
      <Row
        type="flex"
        align="middle"
        justify="space-between"
        className="pickup-driver"
      >
        <Col span={2}>
          <img
            src={
              driverDetails?.image?.url ? driverDetails.image.url : DriverIcon
            }
            style={{ width: "40px", height: "40px", borderRadius: "50%" }}
          />
        </Col>
        <Col span={9}>
          <Row className="driver-name">
            {driverDetails?.first_name ? formatFullName(driverDetails) : "N/A"}
          </Row>
          <Row type="flex" gutter={16}>
            <Col className="driver-id">
              {driverDetails?.employee_code || "N/A"}
            </Col>
            <Col className="driver-num">
              {driverDetails?.mobile_number || "N/A"}
            </Col>
          </Row>
        </Col>
        {!locked && (
        <Tooltip title="Message">
          <Col data-testid="message-button" span={2} onClick={() => setMessageDriver(true)}>
            <MessageIcon color="#576EC1" className="assign-driver-btn" />
          </Col>
        </Tooltip>
        )}
        {!locked && isAssignable && !["COMPLETED", "CLOSED", "ARCHIVED"].includes(currentOrder.status) && (location?.status !== "COMPLETED") && (
          <Tooltip title="Remove from Route">
          <Col data-testid="unassign-button" span={2}>
            <UnassignDriverIcon
              color="#576EC1"
              className="assign-driver-btn"
              onClick={unlinkDriver}
              />
          </Col>
        </Tooltip>
          )}
      </Row>
      {/* <Row type="flex" justify="space-between">
      <Row type="flex">
          <Col style={{paddingRight:"12px"}}>
            {I18n.t("check_ins.check_in")}
          </Col>
          <Col style={{fontWeight:"600"}}> :  {driverDetails?.driver_in_datetime ? <DisplayTime
             dateTimeString={driverDetails?.driver_in_datetime }
             timeFormat={AppConfig.dateTimeFormat}
             displayWithDate={true}
             isUTC={true}
                      /> : 'NA'}
                </Col>
      </Row>
      <Row type="flex">
          <Col style={{paddingRight:"2px"}}>
          {I18n.t("check_ins.check_out")}
          </Col>
          <Col style={{fontWeight:"600"}}> : {driverDetails?.driver_out_datetime ? <DisplayTime
             dateTimeString={driverDetails?.driver_out_datetime }
             timeFormat={AppConfig.dateTimeFormat}
             displayWithDate={true}
             isUTC={true}
                      /> : 'NA'}
          </Col>   
      </Row>
      </Row> */}

      {messageDriver && (
        <MessageDriver
          messageDriver={messageDriver}
          setMessageDriver={setMessageDriver}
          drivers={drivers}
          driverDetails={driverDetails}
        />
      )}
    </Spin>
  );
};

export default AssignedDriver;
